<div *ngIf="message" class="message {{ cssClass(message) }}">
    {{ message.text }}

    <div *ngIf="message.alertType === 1">
        {{ 'UTILS.MESSAGE.ALERT_1' | translate }}
    </div>

    <button (click)="clear()">{{ 'SHARED.OK' | translate | uppercase }}</button>
</div>
